import React, { useContext, useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AuthContext from '../contexts/AuthContext';

export default function UserMenu() {
  const { logout } = useContext(AuthContext);
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);
  const navigate = useNavigate();
  const username = localStorage.getItem('username') || 'User';

  useEffect(() => {
    if (!open) return undefined;
    const onDoc = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', onDoc);
    return () => document.removeEventListener('mousedown', onDoc);
  }, [open]);

  const handleLogout = () => {
    setOpen(false);
    logout();
    navigate('/login');
  };

  return (
    <div ref={wrapRef} className="relative">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="px-3 py-1 bg-surface-panel border border-surface-border text-sm text-surface-text hover:bg-surface-border/60 transition-colors rounded-[2px]"
      >
        {username} ▾
      </button>
      {open && (
        <div className="absolute right-0 mt-1 min-w-[140px] bg-surface-panel border border-surface-border rounded-[2px] shadow-lg z-40">
          <button
            type="button"
            onClick={handleLogout}
            className="block w-full text-left px-3 py-2 text-xs uppercase tracking-wider text-steam-danger hover:bg-surface-border/60"
          >
            Log out
          </button>
        </div>
      )}
    </div>
  );
}
